import Vue from 'vue';
import api from './../../lib/api';
import _ from 'lodash';

export const FETCH_SKILLS = 'FETCH_SKILLS';
export const FETCH_SKILL = 'FETCH_SKILL';
export const CREATE_SKILL = 'CREATE_SKILL';
export const UPDATE_SKILL = 'UPDATE_SKILL';
export const DELETE_SKILL = 'DELETE_SKILL';
export const VALIDATE_SKILL = 'VALIDATE_SKILL';

const SKILLS_LIST_LOADING_CHANGE = 'SKILLS_LIST_LOADING_CHANGE';
const SKILLS_LIST_CHANGE = 'SKILLS_LIST_CHANGE';
const SKILL_CHANGE = 'SKILL_CHANGE';
const SKILL_LOADING_CHANGE = 'SKILL_LOADING_CHANGE';
const SKILL_ERRORS_CHANGE = 'SKILL_ERRORS_CHANGE';
const SKILL_SAVING_CHANGE = 'SKILL_SAVING_CHANGE';

const state = {
    skills_list: [],
    skills_list_meta: {
        total: 0,
        limit: 20,
        offset: 0
    },
    skills_list_loading: false,
    skill: {},
    // Дефолтная структура навыка с пустыми значениями
    skill_empty: {
        name: '',
        tool: 'llm_executor',
        preconditions: '',
        configuration: {},
        input_schema: {}
    },
    skill_loading: false,
    skill_saving: false,
    skill_errors: {},
    // Кэш навыков с ключами по ID
    skills_cache: {},
};

const actions = {
    /**
     * Загружает список навыков
     */
    [FETCH_SKILLS]({ commit, state }, { data = {} }) {
        return api.list(
            'skills.list',
            '',
            data,
            state,
            commit,
            SKILLS_LIST_LOADING_CHANGE,
            SKILLS_LIST_CHANGE,
            null
        );
    },

    /**
     * Загружает данные навыка по ID
     * @param {String} id - ID навыка
     */
    [FETCH_SKILL]({ commit, state }, id) {
        return api.load(
            'skill.by_id',
            id,
            state,
            commit,
            SKILL_LOADING_CHANGE,
            SKILL_CHANGE,
            SKILL_ERRORS_CHANGE
        );
    },

    /**
     * Создает новый навык
     */
    [CREATE_SKILL]({ commit, state }, param) {
        let data = param.data;

        return api.create(
            'skills.create',
            '',
            data,
            state,
            commit,
            SKILL_SAVING_CHANGE,
            SKILL_CHANGE,
            SKILL_ERRORS_CHANGE
        );
    },

    /**
     * Обновляет навык
     */
    [UPDATE_SKILL]({ commit, state }, param) {
        let id = param.id;
        let data = param.data;

        return api.update(
            'skill.update',
            id,
            data,
            state,
            commit,
            SKILL_SAVING_CHANGE,
            SKILL_CHANGE,
            SKILL_ERRORS_CHANGE,
        );
    },

    /**
     * Удаляет навык
     */
    [DELETE_SKILL]({ commit, state }, id) {

        commit(SKILL_SAVING_CHANGE, true);
        return api.delete(
            'skill.delete',
            id,
            state,
            commit,
            SKILL_CHANGE,
        ).finally(() => {
            commit(SKILL_SAVING_CHANGE, false);
        });
    },

    /**
     * Валидирует конфигурацию навыка
     */
    [VALIDATE_SKILL]({ commit, state }, data) {

        return api.create(
            'skill.validate',
            '',
            data,
            state,
            commit,
            SKILL_LOADING_CHANGE,
            null,
            SKILL_ERRORS_CHANGE,
        );
    },
};

const mutations = {
    [SKILLS_LIST_LOADING_CHANGE](state, data) {
        state.skills_list_loading = data;
    },

    [SKILLS_LIST_CHANGE](state, data) {
        if (data?.data) {
            state.skills_list = data.data;
            state.skills_list_meta = {
                total: data.total || 0,
                limit: data.limit || 20,
                offset: data.offset || 0
            };
            // Кэшируем навыки
            data.data.forEach(skill => {
                if (skill.id) {
                    Vue.set(state.skills_cache, skill.id, skill);
                }
            });
        } else {
            state.skills_list = [];
            state.skills_list_meta = {
                total: 0,
                limit: 20,
                offset: 0
            };
        }
    },

    [SKILL_CHANGE](state, data) {
        if (data) {
            state.skill = data;
            if (data.id) {
                Vue.set(state.skills_cache, data.id, data);
            }
        } else {
            state.skill = _.cloneDeep(state.skill_empty);
        }
    },

    [SKILL_LOADING_CHANGE](state, data) {
        state.skill_loading = data;
    },

    [SKILL_SAVING_CHANGE](state, data) {
        state.skill_saving = data;
    },

    [SKILL_ERRORS_CHANGE](state, data) {
        state.skill_errors = data || {};
    },
};

export default {
    state,
    actions,
    mutations
};

